// Cross Browsing
import "react-app-polyfill/ie9";
import "react-app-polyfill/stable";
import "core-js/stable";
import "regenerator-runtime/runtime";

import React from "react";
import ReactDOM from "react-dom/client";
import Root from "./Root";
import "styles/base.scss";
import "styles/baseCommon.scss";

/**
 * dayjs 설정
 */
import dayjs from "dayjs";
import isLeapYear from "dayjs/plugin/isLeapYear"; // 윤년 판단 플러그인
import "dayjs/locale/ko"; // 한국어 가져오기

dayjs.extend(isLeapYear); // 플러그인 등록
dayjs.locale("ko"); // 언어 등록

ReactDOM.createRoot(document.getElementById("root")).render(
	//  <React.StrictMode>
	<Root />
	//  </React.StrictMode>
);
